import { Textfield } from '@shared/fields/text-field';
import { Globe } from 'lucide-react';
import { Label } from '@design-system/label';
import { FormikCountryField } from '@shared/fields/country-field/formik-country-field';

const BankAddressEdit = () => {
  return (
    <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
      <p className='text-gray-600 font-medium text-sm mb-2'>Bank Address</p>
      <div className='grid grid-cols-2 gap-2'>
        <Textfield
          name='address_line_1'
          type='text'
          prefixIcon={<Globe size={18} />}
          placeholder='Address 1'
          label='Address 1'
        />
        <Textfield
          name='address_line_2'
          type='text'
          prefixIcon={<Globe size={18} />}
          placeholder='Address 2'
          label='Address 2 (Optional)'
        />
      </div>
      <Textfield
        name='city'
        type='text'
        prefixIcon={<Globe size={18} />}
        placeholder='ex: cairo'
        label='City'
      />
      <Textfield
        name='state'
        type='text'
        prefixIcon={<Globe size={18} />}
        placeholder='ex: nasr city'
        label='State/ Province (optional)'
      />
      <div className='mb-3'>
        <Label>Country</Label>
        <FormikCountryField selectName={'country'} />
      </div>
      <Textfield
        name='postal_code'
        type='text'
        prefixIcon={<Globe size={18} />}
        placeholder='ex: 124356'
        label='Zip/ Postal Code (optional)'
      />
    </div>
  );
};

export default BankAddressEdit;
